import { globalTooltipStoreApi } from 'modules/globalTooltip';
import type {
  GlobalTooltipConfig,
  GlobalTooltipConfigWithTranslation,
} from 'modules/globalTooltip/store';

export function showTooltip(config: GlobalTooltipConfig): () => void;
export function showTooltip(
  config: GlobalTooltipConfigWithTranslation
): () => void;
export function showTooltip(config: any) {
  const { show, remove } = globalTooltipStoreApi.getState();

  show(config);

  return remove;
}
